import React from "react";
import CommitteeFormPage from "../components/committee/CommitteeFormPage";

const CommitteeEdit = () => <CommitteeFormPage mode="edit" />;

export default CommitteeEdit;
